<p-table [value]="dataSource">
  <ng-template pTemplate="header">
    <tr [class]="'table__header--' + companyEnum.KIL.toLocaleLowerCase()">
      <th class="table__header--uppercase">
        {{ columnLabels.title }}
      </th>
      <th>{{ columnLabels.type }}</th>
      <th>
        <div>{{ columnLabels.meals }}</div>
        (Per week)
      </th>
      <th>{{ columnLabels.bathroom }}</th>
      <th>{{ columnLabels.minAge }}</th>
      <th>
        <div>{{ columnLabels.price }}</div>
        (Per week)
      </th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-data>
    <tr *ngFor="let option of data.options; let first = first; let last = last">
      <td [class.table__cell--no-border-bottom]="!last">
        <ng-container *ngIf="first">
          {{ data.name }} <span>{{ notationMarks[data.noteCode] }}</span>
        </ng-container>
      </td>
      <td>
        {{ option.type ?? '-' }} <span>{{ notationMarks[option.noteCode] }}</span>
      </td>
      <td>{{ option.meals ?? '-' }}</td>
      <td class="bathroom">{{ option.bathroom ?? '-' }}</td>
      <td>{{ option.minAge ?? '-' }}</td>
      <td>{{ option.price | lxPrice : { defaultValue: '-' } }}</td>
    </tr>
  </ng-template>
</p-table>
